<div [class]="classPrefix('MainPod')">
  <section [class]="classPrefix('Pod0')">
    <h4>{{"AiShortsJobZero.comingSoon" | translate}}</h4>
  </section>
</div>
